import { render } from "./ChooseTyreBrands.vue?vue&type=template&id=c5de6e48"
import script from "./ChooseTyreBrands.vue?vue&type=script&lang=js"
export * from "./ChooseTyreBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__